<div class="modal-form--wrapper">
  <div class="modal-form--content" nxModalContent scrollProgress>
    <h3
      *ngIf="data?.modalTitle"
      nxHeadline="subsection-medium"
      class="nx-margin-bottom-3m"
    >
      {{ data.modalTitle || '' | translate }}
    </h3>
    <div class="modal-form--text--wrapper">
      <div
        class="modal-form--text"
        [outerHTML]="data.modalText | translate"
      ></div>
    </div>
  </div>

  <div class="modal-form--footer" nxModalActions>
    <button
      nxButton="block secondary"
      type="button"
      [disabled]="disabled"
      (click)="onClick()"
    >
      {{ data.modalConfirmLabel | translate }}
    </button>
  </div>
</div>
